export default __webpack_public_path__ + "static/media/logo-dark.4f80b7d9.svg";